var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5C23.375 2.5 29.5 8.5625 29.5 16C29.5 23.5 23.4375 29.5 16 29.5C8.5 29.5 2.5 23.5 2.5 16C2.5 8.5625 8.5 2.5 16 2.5ZM16 0.5C7.4375 0.5 0.5 7.5 0.5 16C0.5 24.5625 7.4375 31.5 16 31.5C24.5 31.5 31.5 24.5625 31.5 16C31.5 7.5 24.5 0.5 16 0.5ZM13.75 22C13.3125 22 13 22.375 13 22.75V23.25C13 23.6875 13.3125 24 13.75 24H18.25C18.625 24 19 23.6875 19 23.25V22.75C19 22.375 18.625 22 18.25 22H17.5V13.25C17.5 12.875 17.125 12.5 16.75 12.5H13.75C13.3125 12.5 13 12.875 13 13.25V13.75C13 14.1875 13.3125 14.5 13.75 14.5H14.5V22H13.75ZM16 7C14.875 7 14 7.9375 14 9C14 10.125 14.875 11 16 11C17.0625 11 18 10.125 18 9C18 7.9375 17.0625 7 16 7Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfo);
export default __webpack_public_path__ + "static/media/circle-info.60023444.svg";
export { ForwardRef as ReactComponent };